import React, { FC } from "react";

import { Category } from "../models/categories";
import TruncateEllipsis from "./TruncatePath";

type CategoryNameProps = {
  category: Category;
};

const CategoryName: FC<CategoryNameProps> = ({
  category: { computedTreeFields: { path = [] } = {} },
}) => {
  // The first item in the path will be the root. We don't want to display it
  const fullPath = path.slice(1).map(({ name }) => name);
  return <TruncateEllipsis path={fullPath} />;
};

export default CategoryName;
